module.exports = __webpack_public_path__ + "static/hero-542dfce08dd41780057002a7efc295a1.png";